
import { FC } from 'react';

import { useForm, usePage } from '@inertiajs/react';
import { Mail } from 'lucide-react';

import { Button } from '../../components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../components/ui/Dialog';
import { Routes } from '../../models/routes';
import { CurrentUser } from '../../types';

type Props = {
    show: boolean;
    onClose: () => void;
};

export const EmailConfirmationModal: FC<Props> = ({ show, onClose }) => {
    const { currentUser } = usePage<{ currentUser: CurrentUser }>().props;
    const { post, processing } = useForm({
        user: {
            email: currentUser.email,
        },
    });

    const handleResendConfirmation = () => {
        post(Routes.UserConfirmation, {
            onSuccess: () => {
                onClose();
            },
        });
    };

    return (
        <Dialog open={show} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 text-left">
                        <Mail className="h-5 w-5 text-muted-foreground" />
                        Підтвердження пошти
                    </DialogTitle>
                    <DialogDescription className="mt-3 text-left">
                        Щоб створити першу пропозицію, будь ласка, підтвердіть свою
                        електронну пошту <strong>{currentUser.email}</strong>.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="flex-col gap-2 sm:flex-row sm:justify-start">
                    <Button
                        type="button"
                        variant="default" // Using default variant or verify if 'secondary' exists
                        onClick={handleResendConfirmation}
                        disabled={processing}
                        className="w-full sm:w-auto"
                    >
                        {processing ? 'Відправка...' : 'Надіслати підтвердження'}
                    </Button>
                    <Button
                        type="button"
                        variant="outline"
                        onClick={onClose}
                        className="w-full sm:w-auto"
                    >
                        Закрити
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
